"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitArrayInChunks = void 0;
function splitArrayInChunks(array, chunkSize) {
    if (!array) {
        return [];
    }
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
}
exports.splitArrayInChunks = splitArrayInChunks;
//# sourceMappingURL=array.js.map